import { render, staticRenderFns } from "./formDataDisplay.vue?vue&type=template&id=06a86470&"
import script from "./formDataDisplay.vue?vue&type=script&lang=js&"
export * from "./formDataDisplay.vue?vue&type=script&lang=js&"
import style0 from "./formDataDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports